export function gatherIdentities(
  profile,
  mainIdentity
) {
  const identities = [
    {
      idTypeCd: mainIdentity?.idTypeCd, //R
      idNo: mainIdentity?.idNo, //R
      citizenship: mainIdentity?.citizenship, //R
    },
  ];

  const TIN = profile?.identities?.find(
    identity => identity.idTypeCd === "TAX" && identity.taxType === "EInvoice"
  )?.idNo;

  const CRS = profile?.identities.find(
    identity => identity.idTypeCd === "TAX" && identity.taxType === "CRS"
  );

  if (TIN) {
    identities.push({
      idTypeCd: "TAX",
      idNo: TIN,
      citizenship: "MY",
      taxType: "EInvoice",
    });
  }

  if (CRS) {
    identities.push({
      idTypeCd: "TAX", //R
      idNo: CRS.idNo, //R
      citizenship: CRS.citizenship, //R
      taxType: "CRS",
    });
  }

  return identities;
}
